import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { AboutSection } from '../components/AboutSection';
import { MethodSection } from '../components/MethodSection';
import { ServicesSection } from '../components/ServicesSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FooterCTA } from '../components/FooterCTA';
import { GDPRSection } from '../components/GDPRSection';
export function HomePage() {
  return <main className="min-h-screen w-full font-sans text-body bg-white overflow-x-hidden" data-id="element-248" data-mp="36rvewbgy43o7">
      <Navbar data-id="element-249" data-mp="31y0v781cbop4" />
      <div className="h-16" data-id="element-250" data-mp="31yan515y45xg"></div>
      <HeroSection data-id="element-251" data-mp="2e9rdoib5tn3s" />
      <PainPointsSection data-id="element-252" data-mp="2e97tsw1y8on4" />
      <AboutSection data-id="element-253" data-mp="2e8gaajlmmhd7" />
      <MethodSection data-id="element-254" data-mp="2e7wq0w8i7gw0" />
      <ServicesSection data-id="element-255" data-mp="29ay2wxn9ca7b" />
      <ResourcesSection data-id="element-256" data-mp="29bpu7w9tnlrs" />
      <TestimonialsSection data-id="element-257" data-mp="29aes00w0ym2s" />
      <FooterCTA data-id="element-258" data-mp="2993om26hrgc7" />
      <GDPRSection data-id="element-259" data-mp="2ap4vgoobjn3j" />
    </main>;
}